const styles = {
  Show: {
    display: 'flex',
    transition: 'all 0.3s ease-in-out !important',
  },
  Hide: {
    display: 'none',
    transition: 'all 0.3s ease-in-out !important',
  },
  CityUpdateForm: {
    padding: '0px 0px !important',
    margin: '0px auto !important',
    maxWidth: '600px !important',
  },
  SelectCountry: {
    left: '460px !important',
  },
  FormButtons: {
    color: '#fff !important',
    backgroundColor: '#000000 !important',
    padding: '10px 123px !important',
  },
  CityCancelButton: {
    backgroundColor: 'rgb(255, 42, 42) !important',
    marginRight: '10px !important',
    padding: '10px 123px !important',
  },
  CityFormButtons: {
    padding: '10px 130px !important',
  },
  Buttons: {
    display: 'flex !important',
    flexDirection: 'row !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: '32px 32px 8px 32px !important',
  },
};

export default styles;
